import { render, staticRenderFns } from "./KanbanTicket.vue?vue&type=template&id=0cf35e48&scoped=true"
import script from "./KanbanTicket.vue?vue&type=script&lang=js"
export * from "./KanbanTicket.vue?vue&type=script&lang=js"
import style0 from "./KanbanTicket.vue?vue&type=style&index=0&id=0cf35e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf35e48",
  null
  
)

export default component.exports